import { render, staticRenderFns } from "./Item6.vue?vue&type=template&id=7feb6a11&scoped=true&"
import script from "./Item6.vue?vue&type=script&lang=js&"
export * from "./Item6.vue?vue&type=script&lang=js&"
import style0 from "./Item6.vue?vue&type=style&index=0&id=7feb6a11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7feb6a11",
  null
  
)

export default component.exports